// CacheKey 3d9f58c6d447c4bbc7145ccaa641ac27
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-LHC": {
    filters: {
      arrival: {
        label: "Enrollment Date",
        title: "Filter by enrollment date"
      },
      discharge: {
        label: "Disenrollment Date",
        title: "Filter by disenrollment date"
      },
      encounter: {
        label: "Enrollment",
        title: "Filter by enrollment id"
      },
      facility: {
        label: "State",
        title: "Filter by state"
      },
      unit: {
        label: "Agency",
        title: "Filter by agency"
      }
    }
  }
}

